import { appInsights } from "us.helper";
import { ICase } from "us.collection.transactions/interfaces";

/**
 * @function
 * @description - Check for the selected cases have same additional reference details
 * @param {ICase[]} selectedCases - selected  cases
 * @return {*}  {boolean} - boolean decision for the selected cases have same additional reference details or not
 */
export const isSelectSameAdditionalReferenceCases = (
  selectedCases: ICase[],
): boolean => {
  try {
    return selectedCases.every(
      (c) =>
        c.additionalReference1 === selectedCases[0].additionalReference1 &&
        c.additionalReference2 === selectedCases[0].additionalReference2 &&
        c.additionalReference3 === selectedCases[0].additionalReference3,
    );
  } catch (error) {
    appInsights.trackException(
      `Cases and Subcases Home isCreateCaseButtonDisabled error - ${error}`,
    );
    return false;
  }
};
